import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs md:text-sm flex-wrap">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1.5">
            {idx > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {isLast || !item.href ? (
              <span className="text-foreground-600 font-medium">{item.label}</span>
            ) : (
              <Link
                to={item.href}
                className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}